import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledRow = /*#__PURE__*/styled.tr.withConfig({
  componentId: "sc-storm-ui-40017521__sc-xma118-0"
})(["display:table-row;", ""], isMobile(css(["display:flex;flex-direction:column;&& td:not(:last-child){border-bottom:unset;}"])));
const KeyValueRow = ({
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledRow, _extends({
  role: "row"
}, rest), children);

export { KeyValueRow as K };
//# sourceMappingURL=KeyValueRow-C2RJVJPG.js.map
